import { ComponentLoader } from 'commons';
import loadFunctions from '../generated/load-functions';

ComponentLoader.getLoadFunctions = () => {
    return loadFunctions;
};

export default ComponentLoader;
